import { css } from 'styled-components';
export const withFlex = ({ alignItems, flex, flexDirection, justifyContent, }) => {
    return css `
    display: flex;
    ${alignItems ? `align-items: ${alignItems};` : ''}
    ${flex ? `flex: ${flex};` : ''}
    ${flexDirection ? `flex-direction: ${flexDirection};` : ''}
    ${justifyContent ? `justify-content: ${justifyContent};` : ''}
  `;
};
